<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="logoutconfirmation" tabindex="-1"
    aria-labelledby="logoutconfirmation" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered justify-content-center">
        <div class="modal-content" style="width: 37rem; height: 26rem;">
            <div class="modal-body">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 d-flex justify-content-end px-3 py-3">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div style="padding: 2.7rem; font-size: x-large; text-align: center;">
                            <b>Sei sicuro di voler uscire dalla tua area riservata?</b>
                        </div>
                        <div class="col-md-12 d-flex justify-content-center mt-5">
                            <div class="col-md-6 d-flex justify-content-end px-2" style="border: none;">
                                <button type="button" class="btn btn_style_back"
                                    data-bs-dismiss="modal">Annulla</button>
                            </div>
                            <div class="col-md-6 d-flex justify-content-start px-2">
                                <button type="button" class="btn btn_style_confirm" data-bs-dismiss="modal" (click)="logoutConfirmation()">Torna alla home</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>